import type { RouteLocationNormalized, Router } from 'vue-router'

// Where a navigation still under way is heading: its page may take a moment to load
let pendingNavigation: RouteLocationNormalized | null = null

export const trackPendingNavigation = (router: Router) => {
  router.beforeEach((to) => {
    pendingNavigation = to
  })
  router.afterEach(() => {
    pendingNavigation = null
  })
  router.onError(() => {
    pendingNavigation = null
  })
}

/** True while the app is heading to another page than `routeName` */
export const isLeavingRoute = (routeName: unknown) => !!pendingNavigation && pendingNavigation.name !== routeName
